// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"174":"88f272f3","641":"0ded3722"}[chunkId] + ".chunk.js";
};